import { createPromise } from '@wix/thunderbolt-commons'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IPageWillMountHandler, IPropsStore, PageFeatureConfigSymbol, Props } from '@wix/thunderbolt-symbols'
import _ from 'lodash'
import { name, ReactLoaderForOOISymbol } from './symbols'
import type { OOIPageComponenetsLoader, OOIPageConfig } from './types'
import { OOIComponentLoader } from './types'

export const ooiLoadComponentsPageWillMount = withDependencies(
	[ReactLoaderForOOISymbol, named(PageFeatureConfigSymbol, name), Props],
	(
		ooiComponentsLoader: OOIComponentLoader,
		{ ooiComponents }: OOIPageConfig,
		propsStore: IPropsStore
	): IPageWillMountHandler & OOIPageComponenetsLoader => {
		const componentsLoadeddDeffered = createPromise<Array<string>>()
		return {
			async pageWillMount() {
				await Promise.all(
					_.map(ooiComponents, async ({ widgetId }, compId) => {
						const ReactComponent = await ooiComponentsLoader.getComponent(widgetId)
						propsStore.update({
							[compId]: {
								ReactComponent,
							},
						})
					})
				)

				componentsLoadeddDeffered.resolver(_.map(ooiComponents, ({ widgetId }) => widgetId))
			},
			waitForAllComponentsLoaded() {
				return componentsLoadeddDeffered.promise
			},
		}
	}
)
